import React from "react";
import "./Product.css";
import { useStateValue } from "./StateProvider";
import { store } from "react-notifications-component";
import CustomNotification from "./CustomNotification";

function Product(props) {
  const [{ cart }, dispatch] = useStateValue();
  const addToCart = () => {
    dispatch({
      type: "ADD_TO_CART",
      item: {
        id: props.productId,
        title: props.title,
        image: props.image,
        price: props.price,
        rating: props.rating,
      },
    });

    store.addNotification({
      content: <CustomNotification image={props.image} data={props.title} />,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: false,
      },
    });
  };

  return (
    <div className="product">
      <div className="product__bio">
        <p>{props.title}</p>
        <p className="product__price">
          <small>$</small>
          <strong>{props.price}</strong>
        </p>
        <div className="product__rate">
          {Array(props.rating)
            .fill()
            .map(() => {
              return <p>⭐</p>;
            })}
        </div>
      </div>
      <img src={props.image} alt="product_image" />
      <button onClick={addToCart}>Add to Cart</button>
    </div>
  );
}

export default Product;
